import React from "react";
import { Link } from "react-router-dom";
import { useSettings } from "../../context/SettingsContext";
import { Facebook, Instagram } from "lucide-react";

export default function Footer() {
  const { settings } = useSettings();
  if (!settings) return null;
  const zones = (settings.delivery_zones || []).map((z) => z.nom).join(" · ");

  return (
    <footer className="border-t border-[#E8D5CE] bg-[#2C1A14] text-[#FBF1EE]">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-10 px-4 py-14 sm:grid-cols-2 sm:px-6 lg:grid-cols-4 lg:px-8">
        <div>
          <img src="/logo-yoyo.png" alt="Le Dressing de Yoyo" className="h-32 w-auto" />
          <p className="mt-3 text-sm leading-relaxed text-[#D8C5BD]">
            Une histoire de mode. Une histoire de famille. Un dressing qui se partage.
          </p>
          <div className="mt-4 flex gap-3">
            {settings.social?.facebook && (
              <a href={settings.social.facebook} target="_blank" rel="noreferrer" data-testid="social-facebook" className="hover:text-[#D76E4D]"><Facebook size={20} /></a>
            )}
            {settings.social?.instagram && (
              <a href={settings.social.instagram} target="_blank" rel="noreferrer" data-testid="social-instagram" className="hover:text-[#D76E4D]"><Instagram size={20} /></a>
            )}
          </div>
        </div>

        <div>
          <h4 className="mb-4 font-serif text-lg text-white">Livraison</h4>
          <p className="text-sm leading-relaxed text-[#D8C5BD]">{settings.livraison_info}</p>
          <p className="mt-2 text-xs text-[#9B7E73]">Zones : {zones}</p>
        </div>

        <div>
          <h4 className="mb-4 font-serif text-lg text-white">Aide</h4>
          <ul className="space-y-2 text-sm text-[#D8C5BD]">
            <li><Link to="/histoire" className="hover:text-[#D76E4D]">Notre histoire</Link></li>
            <li><Link to="/suivi" data-testid="footer-track-link" className="hover:text-[#D76E4D]">Suivre ma commande</Link></li>
            <li><Link to="/contact" className="hover:text-[#D76E4D]">Contact & FAQ</Link></li>
            <li><Link to="/contact" className="hover:text-[#D76E4D]">Politique de retour</Link></li>
            <li><Link to="/cgv" className="hover:text-[#D76E4D]">Mentions légales / CGV</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="mb-4 font-serif text-lg text-white">Contact</h4>
          <p className="text-sm text-[#D8C5BD]">{settings.contact_adresse}</p>
          <p className="mt-1 text-sm text-[#D8C5BD]">{settings.contact_email}</p>
          <p className="mt-1 text-sm text-[#D8C5BD]">WhatsApp : {settings.whatsapp_number}</p>
        </div>
      </div>
      <div className="border-t border-white/10 py-4 text-center text-xs text-[#9B7E73]">
        © {new Date().getFullYear()} Le Dressing de Yoyo — Abidjan, Côte d'Ivoire
      </div>
    </footer>
  );
}
